export default __webpack_public_path__ + "static/media/59c3fe655c83489f03d6659676e90364.svg";